module.exports = __webpack_public_path__ + "img/triangle-10.66c28db0.gif";